<template>
  <section class="fdc-main">
    <section class="main-box">
      <section class="logo">
        <img
          src="../../assets/images/code-sandbox.svg"
          class="code-sandbox"
        >
      </section>
      <section class="title">
        <label class="title-label">BRIQUE FDC</label>
      </section>
      <section class="sub-title">
        <label class="sub-title-label">v1.0-r1</label>
      </section>
      <section class="content">
        <p class="content-text">
          BRIQUE FDC monitors and analyzes sensor data
          from equipment in real time in semiconductor/FPD manufacturing industry
          to detect process abnormality, identify abnormality and find root cause
          fault to maximize the utilization of equipment. FDC can improve product yields,
          reduces cycle times, and ultimately increase the productivity of whole factory.
          In addition, recent trends in semiconductor/FPD manufacturing is fast transfer
          and precise analysis of massive data, and BRIQUE FDC is designed
          to adapt dynamically to fulfilling customer needs.
        </p>
      </section>
      <section class="arrow-section">
        <img
          src="../../assets/images/swap-left.svg"
          class="swap-left"
        >
      </section>
      <section class="notice-section">
        <label class="notice-label">Please Select a menu</label>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'Main',
  data () {
    return {

    }
  }
}
</script>

<style src="./Main.scss" lang="scss" scoped/>
